import { Children } from "react";

import { Accordion, Icon, Text } from "@aprosoja/ui";

import { reasonsToSignUp } from "./static";
import useCalculationStep from "./use-calculation-step";
import CalculationStepForm from "./form/form";

const CalculationStep = () => {
  const { doubts } = useCalculationStep();

  return (
    <div className="flex flex-col gap-size-x8">
      <div className="grid grid-cols-1 gap-size-x8 tabletLarge:grid-cols-2">
        <div className="flex flex-col gap-size-x8">
          <Text type="headingL">Calcule sua anuidade</Text>
          <Text type="paragraphL">
            Faça parte da Aprosoja e fortaleça o agro!
          </Text>
          <CalculationStepForm />
        </div>
        <div className="flex flex-col gap-size-x8">
          <Text type="headingL">Porque se associar à Aprosoja?</Text>
          <div className="flex flex-col p-size-x4 gap-size-x2">
            {Children.toArray(
              reasonsToSignUp.map((reason) => (
                <div className="flex gap-size-x4">
                  <Icon
                    name="check"
                    size="size-x8"
                    color="th-primary-color-main"
                  />
                  <Text type="paragraphL">{reason}</Text>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
      {doubts && doubts?.length > 0 && (
        <div className="flex flex-col gap-size-x8">
          <Text type="headingL">Dúvidas</Text>
          <div className="flex flex-col px-size-x6 gap-size-x4">
            {Children.toArray(
              doubts?.map((doubt) => (
                <Accordion
                  trigger={<Text type="headingS">{doubt.title}</Text>}
                  content={<Text type="paragraphL">{doubt.description}</Text>}
                />
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CalculationStep;
